import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

interface IProps {
  /** 노출할 상품 칸 수 (2열 그리드라 짝수 권장) */
  productCount?: number;
}

/**
 * 카테고리 하단 LP(필터바 + 정렬바 + 상품 그리드) 스켈레톤.
 * 위쪽 코너 영역과 API 가 달라서, 응답이 오는 대로 각각 걷어낼 수 있도록 분리했다.
 */
const CategoryLpSkeleton = ({ productCount = 6 }: IProps) => (
  <S.Box className="category-lp-skeleton">
    <ul className="box-lp">
      {Array.from({ length: productCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className="item" key={index}>
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
          <Skeleton className="text03" />
        </li>
      ))}
    </ul>
  </S.Box>
);

export default CategoryLpSkeleton;
